import React from 'react';
import './EventSingle.css';

import { Lightbox, PageSidebar, PageTitle, TeamItem } from '../../../components';
import { speakers } from '../../../constants';
import { getSpeakersByIds } from '../../../utils';

import { FaArrowRight } from 'react-icons/fa';

import { useLocation } from 'react-router-dom';



const EventSingle = () => { 

  // Get the event data from the router state
  const location = useLocation();  
  const event = location.state; 

  // Get the speakers for this event
  const eventSpeakers = getSpeakersByIds(event.speakerIds, speakers);

  return (
    <>
      {/* Page Title */}
      <PageTitle title={event.title} page={"Event Single"} />

      <section className='event-single page-single'>

        <div className='event-info page-info'>

          {/* Event Image */}
          <div className='image'>
            <img src={event.image} alt={event.title} />
          </div>

          <div className='content'>

            {/* Event Heading */}
            <h3 className='main-heading'>{event.title}</h3>

            {/* Event Description */}
            {event.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* Event Image gallery */}
            <Lightbox images={event.gallery} />

            {/* Event Agenda Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Event Agenda:</h3>
              <p>Get a clear overview of the planned sessions, activities, and discussions lined up for {event.title}.</p>

              {/* List of Agenda Points */}
              <ul>
                {event.agenda.map((highlight, index) => (
                  <li key={index}>
                    <FaArrowRight className='icon' />
                    {highlight}
                  </li>
                ))}
              </ul>
            </div>

            {/* Event Speakers Section */}
            <div className='team sub-section'>
              <h3 className='sub-heading'>Event Speakers:</h3>
              <div className='box-container'>
                {eventSpeakers.map((speaker) => (
                  <TeamItem
                    key={speaker.id}
                    team={speaker}
                    type='speaker'
                  />
                ))}
              </div>
            </div> 

            {/* Event Venue Map */}
            <div className="event-map sub-section">
              <h3 className="sub-heading">Event Venue:</h3>
              <iframe
                src={event.venueMap}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Event Venue Map"
              ></iframe> 
            </div>

          </div> 
        
        </div> 

        {/* Sidebar with Event Details */}
        <PageSidebar
          heading={'Event'}
          details={event.details}
          button={{ link: 'Contact-us', title: 'Register Now' }}
        />

      </section>

    </> 
  );
}

export default EventSingle;